// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2t7DY","error":"Textarea_error__whioe","readonly":"Textarea_readonly__Mtayz","disabled":"Textarea_disabled__2lfju"};